import React from 'react'
import styled from 'styled-components'
import { Linea } from './Linea'
import Caja from './Caja'
import Titulo from './Titulo'

const About = () => {
    return (
        <Section>
            <Titulo color='white' titulo='Quienes Somos' />
            <Container>
                <Caja titulo='Misión' texto=' Medellín Amiga es una fundación dedicada a apoyar la educación y el bienestar de niños, niñas y adolescentes en situación de vulnerabilidad. Brindamos un espacio seguro donde pueden fortalecer sus estudios, desarrollar habilidades deportivas y recibir acompañamiento psicosocial. Nuestro propósito es potenciar su desarrollo integral, beneficiando también a sus familias, instituciones educativas y a la sociedad en general.' />
                <Caja titulo='Visión' texto='Ser un referente en la transformación social, brindando a niños, niñas y adolescentes en situación de vulnerabilidad la oportunidad de soñar en grande y alcanzar su máximo potencial. Aspiramos a construir un mundo donde cada niño reciba el apoyo, la educación y las herramientas necesarias para convertirse en el protagonista de su propio futuro, fortaleciendo así a sus familias, sus comunidades y la sociedad en general.' />
            </Container>
        </Section>
    )
}

const Section = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 15px 10%;
    background-color: var(--primary);
    gap: 20px;
`

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
`

export default About